$ ->
  $(document)
    .on 'ajax:success', '.avatars-more', (e, data, status) ->
      dialogContent = """<h4 class="simple-dialog-title">#{data.title || '成员列表'}</h4>#{data.html}"""

      simple.dialog
        content: dialogContent
        buttons: null
        width: 600
        cls: 'dialog-members'
